<!-- Main container -->
<elder-basic-pane-layout class="full">
  <elder-pane>
    <elder-table
      class="flex"
      matSort
      [data]="data"
      [idField]="'id'"
      (itemClick)="openDetail($event)"
    >
      <elder-data-toolbar
        *elderTableToolbar
        (requestNew)="create()"
        [canRemove]="false"
        [canAdd]="true"
        [canMore]="false"
      >
        <ng-template elderToolbarContent="center">
          <elder-search-box
            dense
            class="flex-60 pt-xs"
            queryKey="query"
            [autoPanel]="false"
            [elderSearchContext]="data.filter"
          >
          </elder-search-box>
        </ng-template>
      </elder-data-toolbar>

      <!-- icon -->
      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
        <td mat-cell *matCellDef="let row">
          <mat-icon>label</mat-icon>
        </td>
      </ng-container>

      <!-- id Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'context.id' | translate }}
        </th>
        <td mat-cell *matCellDef="let spec">{{ spec?.id }}</td>
      </ng-container>

      <!-- name Column -->
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'context.name' | translate }}
        </th>
        <td mat-cell *matCellDef="let spec">{{ spec?.name }}</td>
      </ng-container>

      <!-- serialNumber Column -->
      <ng-container matColumnDef="propertyPath">
        <th mat-header-cell *matHeaderCellDef style="width: 15%" mat-sort-header>
          {{ 'batchtracing.serial-number.regex' | translate }}
        </th>
        <td mat-cell *matCellDef="let spec">{{ spec?.serialNumber?.regex }}</td>
      </ng-container>

      <!-- vendors Column -->
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'manufacturer.title' | translate }}
        </th>
        <td mat-cell *matCellDef="let spec">
          <mat-chip-set>
            @for (vendor of spec?.vendors; track vendor) {
              <mat-chip highlighted>{{ vendor }}</mat-chip>
            }
          </mat-chip-set>
        </td>
      </ng-container>
    </elder-table>
  </elder-pane>
</elder-basic-pane-layout>
